let didNotifySessionExpiry = false;

export function notifySessionExpiredOnce(show: (msg: string) => void) {
  if (didNotifySessionExpiry) return;
  didNotifySessionExpiry = true;
  show('Session expired. Please sign in again.');
}

export function resetSessionExpiryNotice() {
  didNotifySessionExpiry = false; // call after a successful re-login if needed
}
